import { useLayoutEffect, useReducer } from "react";

/**
 * 마운트 직후(페인트 전) 한 번 더 렌더한다.
 *
 * 디자인 시스템(@buildblockinc/buildblock-design-system 0.4.x)의 `Checkbox.Control`·`Radio` 내부 control은
 * 크기·색을 렌더 도중 `document.getElementById(rootId).dataset`에서 읽는다. 첫 렌더에는 root가 아직 DOM에 없어
 * 기본값(`color="primary"`, 보라색)으로 그려지고, 나중에 다시 렌더된 항목만 지정한 색이 된다.
 * 디자인 시스템이 고쳐질 때까지 이 hook으로 root가 DOM에 붙은 뒤 한 번 더 렌더해 지정한 값을 읽게 한다.
 */
export function useRerenderAfterMount(): void {
  const [, rerender] = useReducer((count: number) => count + 1, 0);
  useLayoutEffect(() => {
    rerender();
  }, []);
}
